'use client';

/** Search field + category / activatable chips for the skills picker. */

import React from 'react';
import { Search } from 'lucide-react';
import { ALL_CATEGORIES_KEY } from './useSkillCatalog.js';

export function chipClass(active: boolean): string {
  return [
    'inline-flex items-center rounded-md border px-2.5 py-1 text-xs transition-colors',
    active
      ? 'border-primary bg-primary/10 text-foreground'
      : 'border-border bg-card text-muted-foreground hover:bg-muted',
  ].join(' ');
}

export interface SkillFilterChipsProps {
  query: string;
  onQueryChange: (value: string) => void;
  categories: readonly string[];
  category: string;
  onCategoryChange: (value: string) => void;
  activatableOnly: boolean;
  onToggleActivatableOnly: () => void;
}

export function SkillFilterChips({
  query,
  onQueryChange,
  categories,
  category,
  onCategoryChange,
  activatableOnly,
  onToggleActivatableOnly,
}: SkillFilterChipsProps) {
  return (
    <>
      <div className="relative">
        <Search
          className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground"
          aria-hidden
        />
        <input
          type="search"
          value={query}
          onChange={(e) => onQueryChange(e.target.value)}
          placeholder="Search skills…"
          className="w-full pl-9 pr-3 py-2 rounded-md border border-border bg-card text-sm text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary"
          aria-label="Search skills"
        />
      </div>

      <div className="flex flex-wrap gap-2 items-center">
        <button
          type="button"
          className={chipClass(category === ALL_CATEGORIES_KEY)}
          onClick={() => onCategoryChange(ALL_CATEGORIES_KEY)}
        >
          All categories
        </button>
        {categories.map((c) => (
          <button
            key={c}
            type="button"
            className={chipClass(category === c)}
            onClick={() => onCategoryChange(c)}
          >
            {c}
          </button>
        ))}
        <button
          type="button"
          className={chipClass(activatableOnly)}
          onClick={onToggleActivatableOnly}
          title="Only show skills Meridian can run in Hub chat"
        >
          Activatable in Meridian
        </button>
      </div>
    </>
  );
}
